import { useEffect, useState } from 'react';
import { Box } from '@mui/joy';
import ButtonAttribute from '../../Components/ButtonAttribute';
import { faDownload, faCheck, faCloudArrowUp, faFileExport, faFileImport, faPen, faPlus, faTrash, faTruckFast, faListOl } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import DataGridTable from '../../Components/TableData';
import { createTheme, Divider, Grid, ThemeProvider, Typography } from '@mui/material';
import BasicModal from '../../Components/BasicModel';
import axios from 'axios';
import { API } from '../../API/api';
import TextInputMui from '../../Components/TextInputMui';
import AlertBar from '../../Components/AlertBar';
import { saveAs } from 'file-saver';
import * as XLSX from 'xlsx';
import CustomizedProgressBars from '../../Components/CustomizedProgressBars';
import AutocompleteComboBox from '../../Components/AutocompleteComboBox';
import DateTimePickerComponent from '../../Components/DateTimePicker';
import { logOperation } from '../../API/logOperation';
import { format } from 'date-fns';
import dayjs from 'dayjs';
import { toast } from 'react-toastify';

const theme = createTheme({
  typography: {
    fontFamily: 'Inter, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif',
    h4: {
      fontWeight: 700,
      letterSpacing: '-0.025em'
    },
    h6: {
      fontWeight: 600,
      letterSpacing: '-0.025em'
    },
    body1: {
      fontWeight: 500
    }
  },
  palette: {
    mode: 'light',
    primary: {
      main: '#3b82f6',
      light: '#8b9eff',
      dark: '#2563eb'
    },
    secondary: {
      main: '#8b5cf6',
      light: '#a78bfa',
      dark: '#7c3aed'
    },
    background: {
      default: '#f8fafc',
      paper: '#ffffff'
    },
    text: {
      primary: '#1f2937',
      secondary: '#6b7280'
    }
  },
  shape: {
    borderRadius: 8
  },
  components: {
    MuiButton: {
      styleOverrides: {
        root: {
          textTransform: 'none',
          fontWeight: 600,
          borderRadius: 8,
          boxShadow: 'none',
          '&:hover': {
            boxShadow: '0 4px 12px rgba(0, 0, 0, 0.15)'
          }
        }
      }
    },
    MuiPaper: {
      styleOverrides: {
        root: {
          borderRadius: 12,
          boxShadow: '0 1px 3px rgba(0, 0, 0, 0.1)'
        }
      }
    }
  }
});

export default function StockScelles() {
  const [isLoading, setIsLoading] = useState(0);
  const [importStatus, setImportStatus] = useState('idle');
  const [Scelle, setScelle] = useState([]);
  const [openAjouterScelle, setOpenAjouterScelle] = useState(false);
  const [openModifierScelle, setOpenModifierScelle] = useState(false);
  const [openDeleteScelle, setOpenDeleteScelle] = useState(false);
  const [openExtrationScelle, setOpenExtrationScelle] = useState(false);
  const [openImportationScelle, setOpenImportationScelle] = useState(false);
  const [openConfirmationPassword, setOpenConfirmationPassword] = useState(false);
  const [rowsSelected, setRowsSelected] = useState([]);
  const [Permissions, setPermissions] = useState([]);
  const [role, setRole] = useState('');
  const [errors, setErrors] = useState({ error: false, message: '' });
  const [errorsModifier, setErrorsModifier] = useState({ error: false, message: '' });
  const [alertOpen, setAlertOpen] = useState(false);
  const [alertOpenSelectedModifier, setAlertOpenSelectedModifier] = useState(false);
  const [alertOpenNotModiferRow, setAlertOpenNotModiferRow] = useState(false);
  const [alertOpenUpdatedScelle, setAlertOpenUpdatedScelle] = useState(false);
  const [alertOpenDeletedScelle, setAlertOpenDeletedScelle] = useState(false);
  const [alertOpenPasswordNotValid, setAlertOpenPasswordNotValid] = useState(false);
  const [alertOpenMultiDeletedScelle, setAlertOpenMultiDeletedScelle] = useState(false);
  const [alertOpenNotSelectedLineExtration, setAlertOpenNotSelectedLineExtration] = useState(false);
  const [alertOpenImport, setAlertOpenImport] = useState(false);
  const [alertErrorImport, setAlertErrorImport] = useState(false);

  // Affectation chauffeur
  const [openAffecterScelle, setOpenAffecterScelle] = useState(false);
  const [chauffeurs, setChauffeurs] = useState([]);
  const [chauffeurId, setChauffeurId] = useState(null);
  const [alertOpenAffect, setAlertOpenAffect] = useState(false);
  const [alertOpenAffectError, setAlertOpenAffectError] = useState(false);
  const [alertOpenNoChauffeur, setAlertOpenNoChauffeur] = useState(false);

  // Batch Scellés
  const [openBatchScelle, setOpenBatchScelle] = useState(false);
  const [batchScelle, setBatchScelle] = useState({
    firstNumber: '',
    quantity: '',
    statut: 'Disponible',
    date_entree: dayjs().format('YYYY-MM-DD'),
  });
  const [batchProgress, setBatchProgress] = useState(0);
  const [isBatchLoading, setIsBatchLoading] = useState(false);
  const [alertOpenBatchOk, setAlertOpenBatchOk] = useState(false);
  const [alertOpenBatchErr, setAlertOpenBatchErr] = useState(false);

  const [newScelle, setNewScelle] = useState({
    numero_scelle: '',
    statut: 'Disponible',
    date_entree: '',
    commentaire: '',
    affecte_a: '',
    utilise: false,
  });

  const [modifierScelle, setModifierScelle] = useState({
    id: '',
    numero_scelle: '',
    statut: 'Disponible',
    date_entree: '',
    commentaire: '',
    affecte_a: '',
    utilise: false,
  });

  const [ConfrimedPassword, setConfirmedPassword] = useState({ password: '', errors: '' });

  const getPermission = (permissions, section, actionName) => {
    const sectionPermissions = permissions.find((perm) => perm.name === section);
    if (!sectionPermissions) return 0;
    const action = sectionPermissions.actions.find((act) => act.name === actionName);
    return action?.allowed ?? 0;
  };

  const isAllowedAjouterScelle = getPermission(Permissions, 'Logistique', 'ajouter Scelle');
  const isAllowedModifierScelle = getPermission(Permissions, 'Logistique', 'modifier Scelle');
  const isAllowedSupprimerScelle = getPermission(Permissions, 'Logistique', 'supprimer Scelle');
  const isAllowedExporterScelle = getPermission(Permissions, 'Logistique', 'exporter Scelle');
  const isAllowedImporterScelle = getPermission(Permissions, 'Logistique', 'importer Scelle');

  useEffect(() => {

    const storedAuthState = sessionStorage.getItem('authLocalstorage');
    const parsedAuthState = JSON.parse(storedAuthState || '{}');
    localStorage.removeItem('selectedRows');
    if (parsedAuthState?.token) {
      setPermissions(parsedAuthState.permissions || []);
      setRole(parsedAuthState.user?.role?.name || '');
      fetchScelle(parsedAuthState.token);
      fetchChauffeurs();
      const itv = setInterval(() => {
        setErrors({ error: false, message: '' });
        setErrorsModifier({ error: false, message: '' });
      }, 10000);
      return () => clearInterval(itv);
    }
  }, []);

  const fetchScelle = async (token) => {
    try {
      const res = await axios.get(`${API}/scelles`, { headers: { Authorization: `Bearer ${token}` } });
      setScelle(res.data.data);
    } catch {
      setErrors({ error: true, message: 'Failed to fetch Scelle' });
    }
  };

  const fetchChauffeurs = async () => {
    const storedAuthState = sessionStorage.getItem('authLocalstorage');
    const parsedAuthState = JSON.parse(storedAuthState || '{}');
    try {
      const res = await axios.get(`${API}/chauffeurs`, { headers: { Authorization: `Bearer ${parsedAuthState.token}` } });
      setChauffeurs(res.data.data);
    } catch {
      setChauffeurs([]);
    }
  };

  const handleOpen = () => setOpenAjouterScelle(true);
  const handleClose = () => setOpenAjouterScelle(false);
  const handleOpenModifier = () => {
    const selected = JSON.parse(localStorage.getItem('selectedRows') || '[]');
    if (selected.length > 0) {
      setOpenModifierScelle(true);
      setRowsSelected(selected);
      setModifierScelle(selected[0]);
    } else setAlertOpenSelectedModifier(true);
  };
  const handleCloseModifier = () => setOpenModifierScelle(false);
  const handleOpenDeleteScelle = () => {
    const selected = JSON.parse(localStorage.getItem('selectedRows') || '[]');
    if (selected.length > 0) {
      setOpenDeleteScelle(true);
      setRowsSelected(selected);
      setModifierScelle(selected[0]);
    } else setAlertOpenSelectedModifier(true);
  };
  const handleCloseDeleteScelle = () => setOpenDeleteScelle(false);
  const handleOpenExtrationScelle = () => setOpenExtrationScelle(true);
  const handleCloseExtrationScelle = () => setOpenExtrationScelle(false);
  const handleOpenImportationScelle = () => setOpenImportationScelle(true);
  const handleCloseImportationScelle = () => setOpenImportationScelle(false);
  const handleOpenConfirmationPassword = () => setOpenConfirmationPassword(true);
  const handleCloseConfirmationPassword = () => setOpenConfirmationPassword(false);

  const handleOpenAffecterScelle = async () => {
    const selected = JSON.parse(localStorage.getItem('selectedRows') || '[]');
    if (!selected.length) {
      setAlertOpenSelectedModifier(true);
      return;
    }
    setRowsSelected(selected);
    setModifierScelle(selected[0]);
    await fetchChauffeurs();
    setOpenAffecterScelle(true);
  };
  const handleCloseAffecterScelle = () => {
    setOpenAffecterScelle(false);
    setChauffeurId(null);
  };

  const handleOpenBatchScelle = () => setOpenBatchScelle(true);
  const handleCloseBatchScelle = () => {
    setOpenBatchScelle(false);
    setBatchProgress(0);
  };

  const handleOpenModifierOneScelle = async () => {
    const storedAuthState = sessionStorage.getItem('authLocalstorage');
    const parsedAuthState = JSON.parse(storedAuthState || '{}');
    const ID = rowsSelected[0].id;

    const noChange =
      rowsSelected[0].numero_scelle === modifierScelle.numero_scelle &&
      rowsSelected[0].statut === modifierScelle.statut &&
      rowsSelected[0].date_entree === modifierScelle.date_entree &&
      rowsSelected[0].commentaire === modifierScelle.commentaire &&
      rowsSelected[0].affecte_a === modifierScelle.affecte_a &&
      rowsSelected[0].utilise === modifierScelle.utilise;

    if (noChange) {
      setAlertOpenNotModiferRow(true);
      return;
    }

    const missingFields = [];

    if (!modifierScelle.numero_scelle || modifierScelle.numero_scelle.trim() === "") {
      missingFields.push("Numéro de scellé");
    }

    if (!modifierScelle.statut || modifierScelle.statut.trim() === "") {
      missingFields.push("Statut");
    }

    if (missingFields.length > 0) {
      setErrorsModifier({
        error: true,
        message: `Champs obligatoires manquants : ${missingFields.join(", ")}`
      });
      return;
    }

    try {
      await axios.put(
        `${API}/scelles/${ID}`,
        {
          numero_scelle: modifierScelle.numero_scelle,
          statut: modifierScelle.statut,
          date_entree: modifierScelle.date_entree,
          commentaire: modifierScelle.commentaire,
          affecte_a: modifierScelle.affecte_a,
          utilise: modifierScelle.utilise,
        },
        { headers: { Authorization: `Bearer ${parsedAuthState.token}` } }
      );

      setAlertOpenUpdatedScelle(true);
      handleCloseModifier();
      fetchScelle(parsedAuthState.token);
      logOperation({
        operation_type: 'Modification',
        entity_type: 'Scellé',
        entity_id: parsedAuthState.user.id,
        description: `Modification du scellé ID ${ID}`,
      });
    } catch {
      setErrorsModifier({ error: true, message: 'Une erreur est survenue lors de la modification.' });
    }
  };

  const handleDeleteScelle = async () => {
    const storedAuthState = sessionStorage.getItem('authLocalstorage');
    const parsedAuthState = JSON.parse(storedAuthState || '{}');
    const ID = rowsSelected[0].id;
    try {
      await axios.delete(`${API}/scelles/${ID}`, { headers: { Authorization: `Bearer ${parsedAuthState.token}` } });
      handleCloseDeleteScelle();
      setAlertOpenDeletedScelle(true);
      logOperation({
        operation_type: 'Delete',
        entity_type: 'Scelle',
        entity_id: parsedAuthState.user.id,
        description: 'Delete Scelle',
      });
      fetchScelle(parsedAuthState.token);
    } catch { }
  };

  const handleDeleteMultiScelle = async () => {
    const storedAuthState = sessionStorage.getItem('authLocalstorage');
    const parsedAuthState = JSON.parse(storedAuthState || '{}');
    try {
      await Promise.all(
        rowsSelected.map((row) => axios.delete(`${API}/scelles/${row.id}`, { headers: { Authorization: `Bearer ${parsedAuthState.token}` } }))
      );
      handleCloseDeleteScelle();
      setAlertOpenMultiDeletedScelle(true);
      logOperation({
        operation_type: 'Delete Multiple',
        entity_type: 'Scelle',
        entity_id: parsedAuthState.user.id,
        description: 'Delete Multiple Scelle',
      });
      fetchScelle(parsedAuthState.token);
    } catch { }
  };

  const handleVerificationPassword = () => {
    const storedAuthState = sessionStorage.getItem('authLocalstorage');
    const parsedAuthState = JSON.parse(storedAuthState || '{}');
    const email = parsedAuthState.user.email;
    const password = ConfrimedPassword.password;

    axios
      .post(`${API}/verify-password`, { email, password })
      .then((res) => {
        if (res.data.success) {
          if (rowsSelected.length === 1) handleDeleteScelle();
          else handleDeleteMultiScelle();
          handleCloseConfirmationPassword();
        } else {
          setConfirmedPassword({ errors: true });
          setAlertOpenPasswordNotValid(true);
        }
      })
      .catch(() => {
        setConfirmedPassword({ errors: true });
        setAlertOpenPasswordNotValid(true);
      });
  };

  const handleExtrationAllScelle = () => {
    const storedAuthState = sessionStorage.getItem('authLocalstorage');
    const parsedAuthState = JSON.parse(storedAuthState || '{}');
    if (!Scelle?.length) return;

    const dataForExcel = Scelle.map((row) => {
      const out = {};
      columns.forEach((col) => {
        const v = row[col.accessorKey];
        if (col.accessorKey === 'utilise') out[col.header] = v ? 'Oui' : 'Non';
        else if (col.accessorKey === 'date_entree') {
          const d = v ? new Date(v) : null;
          out[col.header] = d && !isNaN(d.getTime()) ? d.toLocaleDateString('fr-FR') : '';
        } else out[col.header] = v ?? '';
      });
      return out;
    });

    const ws = XLSX.utils.json_to_sheet(dataForExcel);
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, 'Scelles');
    const buf = XLSX.write(wb, { bookType: 'xlsx', type: 'array' });
    saveAs(new Blob([buf], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' }), 'Stock_Scelles_Complet.xlsx');

    logOperation({
      operation_type: 'Extraction',
      entity_type: 'Scelle',
      entity_id: parsedAuthState.user.id,
      description: 'Extraction complète des scellés',
    });
  };

  const handleExtrationSelectionsScelle = () => {
    const storedAuthState = sessionStorage.getItem('authLocalstorage');
    const parsedAuthState = JSON.parse(storedAuthState || '{}');
    const selected = JSON.parse(localStorage.getItem('selectedRows') || '[]');
    if (!selected.length) {
      setAlertOpenNotSelectedLineExtration(true);
      return;
    }

    const dataForExcel = selected.map((row) => {
      const out = {};
      columns.forEach((col) => {
        const v = row[col.accessorKey];
        if (col.accessorKey === 'utilise') out[col.header] = v ? 'Oui' : 'Non';
        else if (col.accessorKey === 'date_entree') {
          const d = v ? new Date(v) : null;
          out[col.header] = d && !isNaN(d.getTime()) ? d.toLocaleDateString('fr-FR') : '';
        } else out[col.header] = v ?? '';
      });
      return out;
    });

    const ws = XLSX.utils.json_to_sheet(dataForExcel);
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, 'Scellés');
    const buf = XLSX.write(wb, { bookType: 'xlsx', type: 'array' });
    saveAs(new Blob([buf], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' }), 'Stock_Scelles.xlsx');

    logOperation({
      operation_type: 'Extraction',
      entity_type: 'Scelle',
      entity_id: parsedAuthState.user.id,
      description: 'Extraction Scelle vers fichier Excel',
    });
  };

  const handleDownload = () => {
    const a = document.createElement('a');
    a.href = `/ImportScelles.xlsx`;
    a.download = 'ImportScelles.xlsx';
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
  };

  const triggerFileInput = () => document.getElementById('file-upload')?.click();

  const handleFileImport = (event) => {
    const file = event.target.files[0];
    if (!file) return;

    const reader = new FileReader();
    const storedAuthState = sessionStorage.getItem("authLocalstorage");
    const parsedAuthState = JSON.parse(storedAuthState || "{}");
    const token = parsedAuthState?.token;

    reader.onload = async (e) => {
      try {
        const wb = XLSX.read(e.target.result, { type: "binary" });
        const sheet = wb.Sheets[wb.SheetNames[0]];
        const jsonData = XLSX.utils.sheet_to_json(sheet, { defval: "" });

        if (!jsonData.length) {
          toast.error("Le fichier est vide.");
          return;
        }

        /* ===============================
           CHECK REQUIRED COLUMNS
        =============================== */

        const requiredColumns = ["Numero scelle"];

        const fileColumns = Object.keys(jsonData[0]);
        const missingColumns = requiredColumns.filter(
          (col) => !fileColumns.includes(col)
        );

        if (missingColumns.length > 0) {
          toast.error(
            `Colonnes obligatoires manquantes : ${missingColumns.join(", ")}`
          );
          return;
        }

        /* ===============================
           VALIDATE ROWS
        =============================== */

        const validRows = [];
        const invalidRows = [];

        jsonData.forEach((row, index) => {
          const numero_scelle = row["Numero scelle"]?.toString().trim();

          if (!numero_scelle) {
            invalidRows.push(index + 2);
          } else {
            validRows.push({ row, line: index + 2 });
          }
        });

        if (invalidRows.length > 0) {
          toast.error(
            `Import annulé. Numero scelle manquant aux lignes : ${invalidRows.join(", ")}`
          );
          return;
        }

        /* ===============================
           START INSERT
        =============================== */

        setIsLoading(0);
        setImportStatus("processing");

        let successCount = 0;
        let failedCount = 0;
        const successLines = [];
        const failedLines = [];

        for (let i = 0; i < validRows.length; i++) {
          const { row, line } = validRows[i];

          const payload = {
            numero_scelle: row["Numero scelle"]?.toString().trim(),
            statut: row["Statut"]?.toString().trim() || "Disponible",
            date_entree: row["Date entree"]
              ? new Date(row["Date entree"]).toISOString().split("T")[0]
              : null,
            commentaire: row["Commentaire"]?.toString().trim() || "",
            affecte_a: row["Affecte a"]?.toString().trim() || null,
            utilise:
              row["Utilise"]?.toString().toLowerCase() === "oui" ||
              row["Utilise"] === true ||
              row["Utilise"] === 1,
          };

          try {
            await axios.post(`${API}/scelles`, payload, {
              headers: { Authorization: `Bearer ${token}` },
            });

            successCount++;
            successLines.push(line);
          } catch (error) {
            failedCount++;
            failedLines.push(line);
            console.error("Erreur ligne", line, error);
          }

          setIsLoading(((i + 1) / validRows.length) * 100);
        }

        /* ===============================
           FINAL RESULT
        =============================== */

        if (failedCount > 0) {
          setImportStatus("error");

          toast.error(
            `Import terminé.

✅ Succès : ${successCount}
❌ Échecs : ${failedCount}

Lignes insérées : ${successLines.join(", ") || "Aucune"}
Lignes échouées : ${failedLines.join(", ") || "Aucune"}`
          );
        } else {
          setImportStatus("success");

          toast.success(
            `Importation réussie !

${successCount} scellé(s) ajouté(s)
Lignes : ${successLines.join(", ")}`
          );
        }

        fetchScelle(token);

        logOperation({
          operation_type: "AJOUTER",
          entity_type: "Scelle",
          entity_id: parsedAuthState.user?.id,
          description: "Importation multiple de scellés",
        });

        setTimeout(() => {
          setIsLoading(0);
          setImportStatus("idle");
        }, 4000);

      } catch (err) {
        console.error("Erreur globale import:", err);
        setImportStatus("error");
        toast.error("Erreur inattendue pendant l'import.");
        setIsLoading(0);
      }
    };

    reader.readAsBinaryString(file);
  };

  const handleAjouterScelle = () => {
    const storedAuthState = sessionStorage.getItem('authLocalstorage');
    const parsedAuthState = JSON.parse(storedAuthState || '{}');

    const missingFields = [];

    if (!newScelle.numero_scelle || newScelle.numero_scelle.trim() === "") {
      missingFields.push("Numéro de scellé");
    }

    if (!newScelle.date_entree) {
      missingFields.push("Date d'entrée");
    }

    if (missingFields.length > 0) {
      setErrors({
        error: true,
        message: `Champs obligatoires manquants : ${missingFields.join(", ")}`
      });
      return;
    }

    axios
      .post(
        `${API}/scelles`,
        {
          numero_scelle: newScelle.numero_scelle,
          statut: newScelle.statut || 'Disponible',
          date_entree: newScelle.date_entree,
          commentaire: newScelle.commentaire || '',
          affecte_a: newScelle.affecte_a || '',
          utilise: newScelle.utilise,
        },
        { headers: { Authorization: `Bearer ${parsedAuthState.token}` } }
      )
      .then(() => {
        handleClose();
        setAlertOpen(true);
        fetchScelle(parsedAuthState.token);
        setNewScelle({
          numero_scelle: '',
          statut: 'Disponible',
          date_entree: '',
          commentaire: '',
          affecte_a: '',
          utilise: false,
        });
        logOperation({
          operation_type: 'Ajout',
          entity_type: 'Scelle',
          entity_id: parsedAuthState.user.id,
          description: 'Ajout de scellé dans le stock',
        });
      })
      .catch((err) => {
        console.error('Error adding scelle:', err);
        setErrors({ error: true, message: "Échec de l'ajout du scellé. Vérifiez les données." });
      });
  };

  const handleAffecterSubmit = async () => {
    const storedAuthState = sessionStorage.getItem('authLocalstorage');
    const parsedAuthState = JSON.parse(storedAuthState || '{}');

    if (!rowsSelected.length) {
      setAlertOpenSelectedModifier(true);
      return;
    }
    if (!chauffeurId) {
      setAlertOpenNoChauffeur(true);
      return;
    }

    const id = rowsSelected[0].id;

    try {
      await axios.put(
        `${API}/scelles/affecterChauffeur/${id}`,
        { affecte_a: chauffeurId },
        { headers: { Authorization: `Bearer ${parsedAuthState.token}` } }
      );

      fetchScelle(parsedAuthState.token);
      setOpenAffecterScelle(false);
      setAlertOpenAffect(true);

      logOperation({
        operation_type: 'Affectation',
        entity_type: 'Scelle',
        entity_id: parsedAuthState.user.id,
        description: `Scellé ${id} affecté`,
      });
    } catch {
      setAlertOpenAffectError(true);
    }
  };

  // helpers
  const toInt = (s) => Number.parseInt(String(s).trim(), 10);
  const addStrNums = (a, b) => {
    let i = a.length - 1,
      j = b.length - 1,
      carry = 0,
      out = '';
    while (i >= 0 || j >= 0 || carry) {
      const da = i >= 0 ? a.charCodeAt(i) - 48 : 0;
      const db = j >= 0 ? b.charCodeAt(j) - 48 : 0;
      const sum = da + db + carry;
      out = String(sum % 10) + out;
      carry = (sum / 10) | 0;
      i--;
      j--;
    }
    return out.replace(/^0+(?=\d)/, '');
  };
  const chunk = (arr, size) =>
    Array.from({ length: Math.ceil(arr.length / size) }, (_, k) => arr.slice(k * size, k * size + size));

  const handleGenerateScelles = async () => {
    const storedAuthState = sessionStorage.getItem('authLocalstorage');
    const parsedAuthState = JSON.parse(storedAuthState || '{}');

    const raw = String(batchScelle.firstNumber ?? '').trim();
    const qty = toInt(batchScelle.quantity);
    if (!Number.isFinite(qty) || qty <= 0) return;

    const m = raw.match(/^(\D*)(\d+)$/);
    if (!m) return;
    const [, prefix, startNumStr] = m;
    const width = startNumStr.length;

    const items = Array.from({ length: qty }, (_, i) => {
      const n = addStrNums(startNumStr, String(i));
      const padded = n.length < width ? n.padStart(width, '0') : n;
      return {
        numero_scelle: `${prefix}${padded}`,
        statut: 'Disponible',
        date_entree: batchScelle.date_entree,
        utilise: false,
        commentaire: '',
        affecte_a: null,
      };
    });

    setBatchProgress(0);
    setIsBatchLoading(true);

    const startTs = Date.now();
    const totalMs = 5000;
    const timer = setInterval(() => {
      const elapsed = Date.now() - startTs;
      const timedPct = Math.min(95, Math.round((elapsed / totalMs) * 95));
      setBatchProgress((prev) => Math.max(prev, timedPct));
      if (elapsed >= totalMs) clearInterval(timer);
    }, 100);

    const parts = chunk(items, 1000);
    let done = 0;
    let hadAnyItemError = false;

    try {
      for (const part of parts) {
        let bulkOk = true;
        try {
          await axios.post(`${API}/scelles/batch`, { items: part }, {
            headers: { Authorization: `Bearer ${parsedAuthState.token}` },
          });
        } catch {
          bulkOk = false;
        }

        if (!bulkOk) {
          // fallback item by item
          for (const it of part) {
            try {
              await axios.post(`${API}/scelles`, it, {
                headers: { Authorization: `Bearer ${parsedAuthState.token}` },
              });
            } catch {
              hadAnyItemError = true;
            }
          }
        }

        done += part.length;
        const workPct = Math.min(95, Math.round((done / items.length) * 95));
        setBatchProgress((prev) => Math.max(prev, workPct));
      }

      const elapsed = Date.now() - startTs;
      if (elapsed < totalMs) await new Promise((r) => setTimeout(r, totalMs - elapsed));

      clearInterval(timer);
      setBatchProgress(100);
      setOpenBatchScelle(false);

      logOperation({
        operation_type: 'Ajout',
        entity_type: 'Scelle',
        entity_id: parsedAuthState?.user?.id,
        description: `Batch scellés ${items[0].numero_scelle}..${items[items.length - 1].numero_scelle}`,
      });

      if (hadAnyItemError) {
        setAlertOpenBatchErr(true); // "Génération scellés terminée avec erreurs."
      } else {
        setAlertOpenBatchOk(true);  // succès
      }

      // reset form once at the end
      setBatchScelle({
        firstNumber: '',
        quantity: 1,
        date_entree: new Date().toISOString().split('T')[0],
        affecte_a: null,
        chauffeur: null,
      });

      fetchScelle(parsedAuthState.token);
      setBatchProgress(0);
    } catch {
      clearInterval(timer);
      setAlertOpenBatchErr(true);
    } finally {
      clearInterval(timer);
      setIsBatchLoading(false);
    }
  };


  const columns = [
    { accessorKey: 'id', header: 'ID', size: 200 },
    { accessorKey: 'numero_scelle', header: 'Numéro Scellé', size: 200 },
    { accessorKey: 'statut', header: 'Statut', size: 200 },
    {
      accessorKey: 'date_entree',
      header: "Date d'Entrée",
      size: 200,
      Cell: ({ cell }) => {
        const v = cell.getValue();
        const d = v ? new Date(v) : null;
        return d && !isNaN(d.getTime()) ? format(d, 'yyyy-MM-dd') : '';
      },
    },
    {
      accessorKey: 'affecte_a',
      header: 'Affecté à',
      size: 200,
      Cell: ({ cell }) => {
        const v = cell.getValue();
        const c = chauffeurs.find((x) => String(x.id) === String(v));
        const nom = c?.Nom ?? c?.nom ?? '';
        const prenom = c?.Prénom ?? c?.prenom ?? '';
        return (nom || prenom) ? `${nom} ${prenom}`.trim() : '';
      },
    },
    { accessorKey: 'utilise', header: 'utilise', size: 200, Cell: ({ cell }) => (cell.getValue() == 1 ? 'Oui' : 'Non') },
    { accessorKey: 'commentaire', header: 'Commentaire', size: 200 },
  ];

  const MenuButton = () => (
    <Box sx={{
      backgroundColor: '#ffffff',
      border: '1px solid #e5e7eb4b',
      borderRadius: '32px',
      padding: { xs: '20px', md: '30px' },
      marginBottom: '20px',
      boxShadow: "0 4px 6px rgba(99, 102, 241, 0.2)",
    }}>

      {/* Header Section */}
      <Box sx={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        marginBottom: '20px',
        paddingBottom: '16px',
        borderBottom: '1px solid #f3f4f6'
      }}>
        <Box sx={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
          <Box sx={{
            width: '40px',
            height: '40px',
            borderRadius: '6px',
            backgroundColor: '#3b82f6',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center'
          }}>
            <FontAwesomeIcon icon={faTruckFast} style={{ color: 'white', fontSize: '16px' }} />
          </Box>
          <Typography variant="h4" sx={{
            fontWeight: 600,
            color: '#1f2937',
            fontSize: { xs: '1.25rem', md: '1.5rem' },
            letterSpacing: '-0.025em'
          }}>
            Gestion des Scellés Douane
          </Typography>
        </Box>

        <Typography variant="body2" sx={{
          color: '#6b7280',
          fontSize: '14px',
          fontWeight: 500,
          backgroundColor: '#f9fafb',
          padding: '6px 12px',
          borderRadius: '6px',
          border: '1px solid #e5e7eb'
        }}>
          {Scelle.length} scellé{Scelle.length !== 1 ? 's' : ''}
        </Typography>
      </Box>

      {/* Action Buttons Section */}
      <Box sx={{
        display: 'flex',
        flexWrap: 'wrap',
        gap: '20px',
        marginTop: '30px',
        alignItems: 'center',
        justifyContent: { xs: 'center', md: 'space-between' }
      }}>
        {/* Primary Actions */}
        <Box sx={{ display: 'flex', gap: '12px', flexWrap: 'wrap' }}>
          {isAllowedAjouterScelle == 1 && (
            <ButtonAttribute
              Label="Ajouter"
              action={handleOpen}
              Bgcolor="#3b82f6"
              color="white"
              bgColorHover="#2563eb"
              type="button"
              height="45px"
              width="150px"
              startIcon={<FontAwesomeIcon color="white" icon={faPlus} style={{ fontSize: '14px' }} />}
              hidden

            />
          )}
          {isAllowedModifierScelle == 1 && (
            <ButtonAttribute
              Label="Modifier"
              action={handleOpenModifier}
              Bgcolor="#f59e0b"
              color="white"
              bgColorHover="#d97706"
              type="button"
              height="45px"
              width="150px"
              startIcon={<FontAwesomeIcon color="white" icon={faPen} style={{ fontSize: '14px' }} />}
              hidden

            />
          )}
          {isAllowedSupprimerScelle == 1 && (
            <ButtonAttribute
              Label="Supprimer"
              action={handleOpenDeleteScelle}
              Bgcolor="#ef4444"
              color="white"
              bgColorHover="#dc2626"
              type="button"
              height="45px"
              width="150px"
              startIcon={<FontAwesomeIcon color="white" icon={faTrash} style={{ fontSize: '14px' }} />}
              hidden

            />
          )}
          <ButtonAttribute
            Label="Affecter"
            action={handleOpenAffecterScelle}
            Bgcolor="#06b6d4"
            color="white"
            bgColorHover="#0891b2"
            type="button"
            height="45px"
            width="150px"
            startIcon={<FontAwesomeIcon color="white" icon={faTruckFast} style={{ fontSize: '14px' }} />}
            hidden

          />
          <ButtonAttribute
            Label="Saisie par lot"
            action={handleOpenBatchScelle}

            Bgcolor="#f97316"
            color="white"
            bgColorHover="#ea580c"
            type="button"
            height="45px"
            width="150px"
            startIcon={<FontAwesomeIcon color="white" icon={faListOl} style={{ fontSize: '14px' }} />}
            hidden

          />
        </Box>

        {/* Secondary Actions */}
        <Box sx={{ display: 'flex', gap: '12px', flexWrap: 'wrap' }}>
          {isAllowedExporterScelle == 1 && (
            <ButtonAttribute
              Label="Exporter"
              action={handleOpenExtrationScelle}
              Bgcolor="#8b5cf6"
              color="white"
              bgColorHover="#7c3aed"

              type="button"
              height="45px"
              width="150px"
              startIcon={<FontAwesomeIcon color="white" icon={faFileExport} style={{ fontSize: '14px' }} />}
              hidden

            />
          )}
          {isAllowedImporterScelle == 1 && (
            <ButtonAttribute
              Label="Importer"
              action={handleOpenImportationScelle}
              Bgcolor="#10b981"
              color="white"
              bgColorHover="#059669"
              type="button"
              height="45px"
              width="150px"
              startIcon={<FontAwesomeIcon color="white" icon={faFileImport} style={{ fontSize: '14px' }} />}
              hidden

            />
          )}
        </Box>
      </Box>
    </Box>
  );

  return (
    <ThemeProvider theme={theme}>
      {role === 'user' || role === 'admin' || role === 'super-admin' || role === 'user-facture' ? (
        <Box
          sx={{
            flexGrow: 1,
            backgroundColor: '#f8fafc',
            padding: { xs: '16px', md: '20px' },
            minHeight: '100vh',
            transition: 'all 0.3s ease-in-out',
          }}
        >
          <MenuButton />
          <Box sx={{
            backgroundColor: 'white',
            borderRadius: '8px',
            boxShadow: '0 1px 3px rgba(0, 0, 0, 0.1)',
            border: '1px solid #e5e7eb',
            overflow: 'hidden'
          }}>
            <DataGridTable data={Scelle} columns={columns} />
          </Box>
        </Box>
      ) : null}

      {/* Ajouter */}
      <BasicModal
        widthSpecial="40%"
        open={openAjouterScelle}
        onClose={handleClose}
        ChildrenContent={
          <Box>
            <Box sx={{

              borderRadius: '6px',
              padding: '20px',
              marginBottom: '20px',
              textAlign: 'center'
            }}>
              <Typography variant="h4" sx={{
                fontSize: { lg: '40px', md: '20px', sm: '18px', xs: '16px' },
                fontFamily: 'Inter, sans-serif',

                fontWeight: 'bold',
                letterSpacing: '-0.025em'
              }}>
                Nouveau Scellé
              </Typography>
            </Box>

            <Grid container spacing={2}>
              <Grid item xs={12}>
                <TextInputMui required label="Numéro Scellé" value={newScelle.numero_scelle} setValue={(e) => setNewScelle({ ...newScelle, numero_scelle: e })} />
              </Grid>

              <Grid item xs={12}>
                <AutocompleteComboBox
                  Label="Statut"
                  widthSpecific="100%"
                  list={[
                    { id: 'Disponible', Nom: 'Disponible' },
                    { id: 'Utilisé', Nom: 'Utilisé' },
                    { id: 'Perdu', Nom: 'Perdu' },
                    { id: 'Endommagé', Nom: 'Endommagé' },
                  ]}
                  keyField="id"
                  valueField="Nom"
                  value={newScelle.statut}
                  onChange={(key) => setNewScelle({ ...newScelle, statut: key })}
                />
              </Grid>
              <Grid item xs={12}>
                <DateTimePickerComponent label="Date d'entrée" required typeDate="date" value={newScelle.date_entree} dateSelected={(e) => setNewScelle({ ...newScelle, date_entree: e })} />
              </Grid>
              <Grid item xs={12}>
                <AutocompleteComboBox
                  Label="Utilisé ?"
                  widthSpecific="100%"
                  list={[
                    { id: 1, Nom: "Oui" },
                    { id: 0, Nom: "Non" },
                  ]}
                  keyField="id"
                  valueField="Nom"
                  value={newScelle.statut == "Utilisé" ? 1 : 0}
                  onChange={(key) =>
                    setNewScelle((prev) => ({
                      ...prev,
                      utilise: key,
                      statut: key == 1 ? "Utilisé" : "Disponible",
                    }))
                  }
                />
              </Grid>
              <Grid item xs={12}>
                <TextInputMui label="Commentaire" value={newScelle.commentaire} setValue={(e) => setNewScelle({ ...newScelle, commentaire: e })} />
              </Grid>
              {errors.error && (
                <Grid item xs={12}>
                  <Typography variant="subtitle1" component="p" sx={{ color: 'red', textAlign: 'center' }}>
                    {errors.message}
                  </Typography>
                </Grid>
              )}
              <Grid item xs={12}>
                <Box sx={{ display: 'flex', justifyContent: 'center' }}>
                  <ButtonAttribute type="submit" Label="Ajouter" color="white" Bgcolor="#28A745" height="60px" width="300px" action={handleAjouterScelle} />
                </Box>
              </Grid>
            </Grid>
          </Box>
        }
      />

      {/* Modifier */}
      <BasicModal
        widthSpecial={'40%'}
        open={openModifierScelle}
        onClose={handleCloseModifier}
        ChildrenContent={
          rowsSelected.length === 1 ? (
            <Box>
              <Typography
                variant="h4"
                sx={{
                  fontSize: { lg: '40px', md: '30px', sm: '30px', xs: '20px' },
                  mb: 2,
                  fontFamily: 'Montserrat , sans-serif',
                  color: '#1D3E62',
                  textAlign: 'center',
                  fontWeight: 'bold',
                  p: '20px',
                }}
              >
                Modifier Scellé ID : {rowsSelected[0].id}
              </Typography>
              <Grid container spacing={2} sx={{ p: '20px' }}>
                <Grid item xs={12}>
                  <TextInputMui label="Numéro Scellé" value={modifierScelle.numero_scelle} setValue={(v) => setModifierScelle((p) => ({ ...p, numero_scelle: v }))} />
                </Grid>

                <Grid item xs={12}>
                  <AutocompleteComboBox
                    Label="Statut"
                    widthSpecific="100%"
                    list={[
                      { id: 'Disponible', Nom: 'Disponible' },
                      { id: 'Utilisé', Nom: 'Utilisé' },
                      { id: 'Perdu', Nom: 'Perdu' },
                      { id: 'Endommagé', Nom: 'Endommagé' },
                    ]}
                    keyField="id"
                    valueField="Nom"
                    value={modifierScelle.statut}
                    onChange={(key) => setModifierScelle((p) => ({ ...p, statut: key }))}
                  />
                </Grid>
                <Grid item xs={12}>
                  <DateTimePickerComponent
                    label="Date d'Entrée"
                    typeDate="date"
                    value={modifierScelle?.date_entree ? dayjs(modifierScelle.date_entree).format('YYYY-MM-DD') : ''}
                    dateSelected={(e) => setModifierScelle((p) => ({ ...p, date_entree: e }))}
                  />
                </Grid>

                <Grid item xs={12}>
                  <AutocompleteComboBox
                    Label="Utilisé ?"
                    disable={true}
                    widthSpecific="100%"
                    list={[
                      { id: 1, Nom: "Oui" },
                      { id: 0, Nom: "Non" },
                    ]}
                    keyField="id"
                    valueField="Nom"
                    value={modifierScelle.statut == "Utilisé" ? 1 : 0}
                    onChange={(key) =>
                      setModifierScelle((p) => ({
                        ...p,
                        utilise: key,
                        statut: key == 1 ? "Utilisé" : "Disponible",
                      }))
                    }
                  />
                </Grid>
                <Grid item xs={12}>
                  <TextInputMui label="Commentaire" multiline value={modifierScelle.commentaire} setValue={(v) => setModifierScelle((p) => ({ ...p, commentaire: v }))} />
                </Grid>
                {errorsModifier.error && (
                  <Grid item xs={12}>
                    <Typography sx={{ color: 'red', textAlign: 'center' }}>{errorsModifier.message}</Typography>
                  </Grid>
                )}
                <Grid item xs={12}>
                  <Box display="flex" justifyContent="center">
                    <ButtonAttribute type="submit" Label="Modifier Scellé" color="white" Bgcolor="#28A745" height="60px" width="300px" action={handleOpenModifierOneScelle} />
                  </Box>
                </Grid>
              </Grid>
            </Box>
          ) : (
            <Typography variant="h4" sx={{ fontSize: '20px', color: '#1D3E62', textAlign: 'center', fontWeight: 600, p: '20px' }}>
              Une seule ligne peut être modifiée à la fois.
            </Typography>
          )
        }
      />

      {/* Supprimer */}
      <BasicModal
        open={openDeleteScelle}
        onClose={handleCloseDeleteScelle}
        ChildrenContent={
          rowsSelected.length === 1 ? (
            <Box>
              <Typography
                variant="h4"
                sx={{
                  fontSize: { lg: '35px', md: '30px', sm: '25px', xs: '20px' },
                  fontFamily: 'Montserrat , sans-serif',
                  color: '#1D3E62',
                  textAlign: 'center',
                  fontWeight: 'bold',
                  p: '10px',
                }}
              >
                Suppression de la Scelle ID : {rowsSelected[0].id}
              </Typography>
              <Typography
                variant="h6"
                sx={{
                  fontSize: { lg: '20px', md: '16px', sm: '14px', xs: '14px' },
                  mb: 1,
                  fontFamily: 'Montserrat , sans-serif',
                  color: '#1D3E62',
                  textAlign: 'center',
                  p: '20px',
                }}
              >
                Voulez-vous vraiment supprimer cette Scelle ?
              </Typography>
              <Box sx={{ display: { xs: 'grid', md: 'flex' }, justifyContent: 'space-evenly', alignItems: 'center', gap: '20px' }}>
                <ButtonAttribute type="submit" Label="Annuler" color={'white'} Bgcolor="gray" height={'50px'} width={'100%'} action={handleCloseDeleteScelle} />
                <ButtonAttribute type="submit" Label="Supprimer" color={'white'} Bgcolor="#DC3545" height={'50px'} width={'100%'} action={handleOpenConfirmationPassword} />
              </Box>
            </Box>
          ) : (
            <Box>
              <Typography
                variant="h4"
                sx={{
                  fontSize: { lg: '35px', md: '30px', sm: '25px', xs: '20px' },
                  fontFamily: 'Montserrat , sans-serif',
                  color: '#1D3E62',
                  textAlign: 'center',
                  fontWeight: 'bold',
                  p: '10px',
                }}
              >
                Suppression des Scellés sélectionnées
              </Typography>
              {rowsSelected.length > 1 ? (
                <Box sx={{ justifyContent: 'center', display: 'flex', gap: '5px', width: '100%', overflowX: 'auto', mb: '20px' }}>
                  {rowsSelected.map((r, i) => (
                    <Box key={i} sx={{ display: 'grid', justifyContent: 'center', alignItems: 'center', mb: '20px', p: '10px', width: '50px', height: '40px', borderRadius: '10%', backgroundColor: '#DC3545' }}>
                      <Typography variant="h6" sx={{ color: '#fff', fontSize: 14, textAlign: 'center', fontFamily: 'Montserrat, sans-serif' }}>
                        {r.id ?? 'N/A'}
                      </Typography>
                    </Box>
                  ))}
                </Box>
              ) : null}
              <Box sx={{ display: { xs: 'grid', md: 'flex' }, justifyContent: 'space-evenly', alignItems: 'center', gap: '20px' }}>
                <ButtonAttribute type="submit" Label="Annuler" color={'white'} Bgcolor="gray" height={'50px'} width={'100%'} action={handleCloseDeleteScelle} />
                <ButtonAttribute type="submit" Label="Supprimer toutes" color={'white'} Bgcolor="#DC3545" height={'50px'} width={'100%'} action={handleOpenConfirmationPassword} />
              </Box>
            </Box>
          )
        }
      />

      {/* Export */}
      <BasicModal
        open={openExtrationScelle}
        onClose={handleCloseExtrationScelle}
        ChildrenContent={
          <Box>
            <Typography
              variant="h4"
              sx={{
                fontSize: { lg: '35px', md: '30px', sm: '25px', xs: '20px' },
                fontFamily: 'Montserrat , sans-serif',
                color: '#1D3E62',
                textAlign: 'center',
                fontWeight: 'bold',
                p: '10px',
              }}
            >
              Extraction des données des Scellés
            </Typography>
            <Typography
              variant="h6"
              sx={{
                fontSize: { lg: '20px', md: '16px', sm: '14px', xs: '14px' },
                mb: 1,
                fontFamily: 'Montserrat , sans-serif',
                color: '#1D3E62',
                textAlign: 'center',
                p: '20px',
              }}
            >
              Extraire l’intégralité ou seulement la sélection.
            </Typography>
            <Box sx={{ display: 'grid', alignItems: 'center', gap: '2px' }}>
              <ButtonAttribute
                type="button"
                Label="Extraire toutes les données (XLSX)"
                Bgcolor="#17A2B8"
                color="white"
                bgColorHover={'#117A8B'}
                height={'70px'}
                width={'100%'}
                endIcon={<FontAwesomeIcon icon={faDownload} color="white" />}
                action={handleExtrationAllScelle}
              />
              <ButtonAttribute
                type="submit"
                Label="Extraire la sélection (XLSX)"
                Bgcolor="#17A2B8"
                color="white"
                bgColorHover={'#117A8B'}
                height={'70px'}
                width={'100%'}
                action={handleExtrationSelectionsScelle}
                endIcon={<FontAwesomeIcon icon={faDownload} color="white" />}
              />
            </Box>
          </Box>
        }
      />

      {/* Import */}
      <BasicModal
        open={openImportationScelle}
        onClose={handleCloseImportationScelle}
        ChildrenContent={
          <Box sx={{ px: 3, py: 2 }}>

            {/* ===== Title ===== */}
            <Typography
              variant="h4"
              sx={{
                fontSize: { lg: 34, md: 28, sm: 24, xs: 20 },
                fontFamily: "Montserrat, sans-serif",
                color: "#1D3E62",
                textAlign: "center",
                fontWeight: 700,
                mb: 1,
              }}
            >
              Importation des Scellés Douaniers
            </Typography>

            {/* ===== Subtitle ===== */}
            <Typography
              variant="body1"
              sx={{
                fontSize: { md: 16, sm: 14, xs: 13 },
                color: "#6B7280",
                textAlign: "center",
                mb: 3,
              }}
            >
              Téléchargez le modèle Excel, complétez les informations requises,
              puis importez votre fichier pour ajouter les scellés.
            </Typography>

            {/* ===== Download Section ===== */}
            <Box
              sx={{
                p: 2,
                borderRadius: "12px",
                border: "1px solid #E5E7EB",
                backgroundColor: "#F9FAFB",
                mb: 3,
              }}
            >
              <ButtonAttribute
                type="button"
                Label="Télécharger le modèle Excel"
                Bgcolor="#2563EB"
                color="white"
                bgColorHover="#1D4ED8"
                height="60px"
                width="100%"
                endIcon={<FontAwesomeIcon icon={faDownload} color="white" />}
                action={handleDownload}
              />
            </Box>

            {/* ===== Upload Section ===== */}
            <Box
              sx={{
                p: 2,
                borderRadius: "12px",
                border: "1px solid #E5E7EB",
                backgroundColor: "#FFFFFF",
              }}
            >
              <Typography
                variant="subtitle1"
                sx={{
                  textAlign: "center",
                  mb: 2,
                  fontWeight: 600,
                  color: "#1D3E62",
                }}
              >
                Sélectionnez votre fichier Excel
              </Typography>

              <ButtonAttribute
                type="button"
                Label="Importer les scellés"
                Bgcolor="#10B981"
                color="white"
                bgColorHover="#059669"
                height="60px"
                width="100%"
                endIcon={<FontAwesomeIcon icon={faCloudArrowUp} color="white" />}
                action={triggerFileInput}
              />

              <input
                id="file-upload"
                type="file"
                accept=".xlsx, .xls, .csv"
                style={{ display: "none" }}
                onChange={handleFileImport}
              />

              {/* ===== Progress Bar ===== */}
              <Box sx={{ mt: 3 }}>
                <CustomizedProgressBars
                  value={isLoading}
                  color={
                    importStatus === "success"
                      ? "success"
                      : importStatus === "error"
                        ? "error"
                        : importStatus === "processing"
                          ? "primary"
                          : "gray"
                  }
                />
              </Box>
            </Box>
          </Box>
        }
      />

      {/* Confirmation password */}
      <BasicModal
        open={openConfirmationPassword}
        onClose={handleCloseConfirmationPassword}
        ChildrenContent={
          <Box>
            <Typography
              variant="h4"
              sx={{
                fontSize: { lg: '35px', md: '30px', sm: '25px', xs: '20px' },
                fontFamily: 'Montserrat , sans-serif',
                color: '#1D3E62',
                textAlign: 'center',
                fontWeight: 'bold',
                p: '20px',
                mb: '20px',
              }}
            >
              Confirmez la suppression
            </Typography>
            <Box sx={{ display: 'grid', justifyContent: 'center', alignItems: 'center', gap: '20px' }}>
              <TextInputMui type="password" label="Mot de passe" name="password" value={ConfrimedPassword.password} setValue={(e) => setConfirmedPassword({ ...ConfrimedPassword, password: e })} required />
              <ButtonAttribute
                type="submit"
                Label="Confirmer la suppression"
                Bgcolor="#17A2B8"
                color="white"
                bgColorHover={'#117A8B'}
                height={'50px'}
                width={'100%'}
                endIcon={<FontAwesomeIcon icon={faCheck} color="white" />}
                action={handleVerificationPassword}
              />
            </Box>
          </Box>
        }
      />

      {/* Affectation chauffeur */}
      <BasicModal
        widthSpecial="40%"
        open={openAffecterScelle}
        onClose={handleCloseAffecterScelle}
        ChildrenContent={
          rowsSelected.length === 1 ? (
            <Box>
              <Typography variant="h4" sx={{ fontSize: { lg: '32px', md: '28px', sm: '24px', xs: '20px' }, mb: 2, fontFamily: 'Montserrat, sans-serif', color: '#1D3E62', textAlign: 'center', fontWeight: 'bold', p: '10px' }}>
                Affecter le scellé ID: {rowsSelected?.[0]?.id}
              </Typography>
              <Grid container spacing={2}>
                <Grid item xs={12}>
                  <AutocompleteComboBox
                    required
                    Label="Chauffeur"
                    widthSpecific="100%"
                    list={chauffeurs}
                    keyField="id"
                    valueField="Nom"
                    DeméValue="Prénom"
                    DueValue
                    dueShowValue
                    value={chauffeurId}
                    onChange={(key) => setChauffeurId(key)}
                  />
                </Grid>
                <Grid item xs={12}>
                  <ButtonAttribute type="button" Label="Affecter" Bgcolor="#0EA5E9" color="white" bgColorHover="#0284C7" height="56px" width="100%" action={handleAffecterSubmit} />
                </Grid>
              </Grid>
            </Box>
          ) : (
            <Typography variant="h4" sx={{ fontSize: '20px', color: '#1D3E62', textAlign: 'center', fontWeight: 600, p: '20px' }}>
              Une seule ligne peut être sélectionnée à la fois.
            </Typography>
          )
        }
      />

      {/* Batch Scellés */}
      <BasicModal
        widthSpecial="40%"
        open={openBatchScelle}
        onClose={handleCloseBatchScelle}
        ChildrenContent={

          <Box>
            <Typography variant="h4" sx={{ fontSize: { lg: '32px', md: '28px', sm: '24px', xs: '20px' }, mb: 2, fontFamily: 'Montserrat, sans-serif', color: '#1D3E62', textAlign: 'center', fontWeight: 'bold', p: '10px' }}>
              Saisie par lot des Scellés
            </Typography>
            <Grid container spacing={2}>
              <Grid item xs={12}>
                <TextInputMui required label="Premier N° Scellé" value={batchScelle.firstNumber} setValue={(v) => setBatchScelle((p) => ({ ...p, firstNumber: v }))} />
              </Grid>
              <Grid item xs={12}>
                <TextInputMui required label="Quantité" type="number" value={batchScelle.quantity} setValue={(v) => setBatchScelle((p) => ({ ...p, quantity: v }))} />
              </Grid>
              <Grid item xs={12}>
                <AutocompleteComboBox Label="Statut" widthSpecific="100%" list={[{ id: 'Disponible', Nom: 'Disponible' }]} keyField="id" valueField="Nom" value={batchScelle.statut} onChange={(key) => setBatchScelle((p) => ({ ...p, statut: key }))} />
              </Grid>
              <Grid item xs={12}>
                <DateTimePickerComponent label="Date d'entrée" typeDate="date" value={batchScelle.date_entree} dateSelected={(e) => setBatchScelle((p) => ({ ...p, date_entree: e }))} />
              </Grid>
              <Grid item xs={12}>
                <ButtonAttribute type="button" Label="Générer et insérer" Bgcolor="#8B5CF6" color="white" bgColorHover="#7C3AED" height="56px" width="100%" action={handleGenerateScelles} />
              </Grid>
              <Grid item xs={12}>
                <CustomizedProgressBars value={batchProgress} color={batchProgress === 100 ? 'success' : 'gray'} />
              </Grid>
              <Grid item xs={12}>
                <Typography sx={{ textAlign: 'center', color: '#1D3E62' }}>Exemple: premier = SC119971000, quantité = 5 → SC119971000 à SC119971004</Typography>
              </Grid>
            </Grid>
          </Box>

        }
      />

      {/* Loading batch */}
      <BasicModal
        open={isBatchLoading}
        onClose={() => { }}
        widthSpecial="30%"
        ChildrenContent={
          <Box sx={{ p: 2, display: 'grid', gap: 2 }}>
            <Typography variant="h6" sx={{ textAlign: 'center', fontWeight: 700 }}>
              Insertion des scellés en cours
            </Typography>
            <CustomizedProgressBars value={batchProgress} color={batchProgress === 100 ? 'success' : 'gray'} />
            <Typography variant="body2" sx={{ textAlign: 'center' }}>
              {batchProgress}% terminé
            </Typography>
          </Box>
        }
      />

      {/* Alerts */}
      <AlertBar open={alertOpen} onClose={() => setAlertOpen(false)} textContent="La Scelle a été ajoutée avec succès." alertColor="success" anchorOrigin={{ vertical: 'bottom', horizontal: 'left' }} />
      <AlertBar open={alertOpenSelectedModifier} onClose={() => setAlertOpenSelectedModifier(false)} textContent="Veuillez choisir une ligne" alertColor="warning" anchorOrigin={{ vertical: 'bottom', horizontal: 'left' }} />
      <AlertBar open={alertOpenNotModiferRow} onClose={() => setAlertOpenNotModiferRow(false)} textContent={'Aucune modification détectée.'} alertColor={'info'} anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }} />
      <AlertBar open={alertOpenUpdatedScelle} onClose={() => setAlertOpenUpdatedScelle(false)} textContent="Scellé mis à jour." alertColor="success" anchorOrigin={{ vertical: 'bottom', horizontal: 'left' }} />
      <AlertBar open={alertOpenDeletedScelle} onClose={() => setAlertOpenDeletedScelle(false)} textContent="Scellé supprimé." alertColor="success" anchorOrigin={{ vertical: 'bottom', horizontal: 'left' }} />
      <AlertBar open={alertOpenPasswordNotValid} onClose={() => setAlertOpenPasswordNotValid(false)} textContent="Mot de passe incorrect." alertColor="error" anchorOrigin={{ vertical: 'bottom', horizontal: 'left' }} />
      <AlertBar open={alertOpenMultiDeletedScelle} onClose={() => setAlertOpenMultiDeletedScelle(false)} textContent="Suppression multiple effectuée." alertColor="success" anchorOrigin={{ vertical: 'bottom', horizontal: 'left' }} />
      <AlertBar open={alertOpenNotSelectedLineExtration} onClose={() => setAlertOpenNotSelectedLineExtration(false)} textContent={'Sélectionnez des lignes pour l’export.'} alertColor={'info'} anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }} />
      <AlertBar open={alertOpenImport} onClose={() => setAlertOpenImport(false)} textContent="Importation effectuée." alertColor="success" anchorOrigin={{ vertical: 'bottom', horizontal: 'left' }} />
      <AlertBar open={alertErrorImport} onClose={() => setAlertErrorImport(false)} textContent="Importation non effectuée. Vérifiez votre fichier." alertColor="error" anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }} />

      <AlertBar open={alertOpenAffect} onClose={() => setAlertOpenAffect(false)} textContent="Scellé affecté avec succès." alertColor="success" anchorOrigin={{ vertical: 'bottom', horizontal: 'left' }} />
      <AlertBar open={alertOpenAffectError} onClose={() => setAlertOpenAffectError(false)} textContent="Échec d'affectation du scellé." alertColor="error" anchorOrigin={{ vertical: 'bottom', horizontal: 'left' }} />
      <AlertBar open={alertOpenNoChauffeur} onClose={() => setAlertOpenNoChauffeur(false)} textContent="Veuillez sélectionner un chauffeur." alertColor="info" anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }} />

      <AlertBar open={alertOpenBatchOk} onClose={() => setAlertOpenBatchOk(false)} textContent="Scellés générés avec succès." alertColor="success" anchorOrigin={{ vertical: 'bottom', horizontal: 'left' }} />
      <AlertBar open={alertOpenBatchErr} onClose={() => setAlertOpenBatchErr(false)} textContent="Génération scellés terminée avec erreurs." alertColor="warning" anchorOrigin={{ vertical: 'bottom', horizontal: 'left' }} />
    </ThemeProvider>
  );
}
